/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Chain_To_Next_EventInputs */



/**
* | output |
* | --- |
* | "Snap the Event outcode to the next Event's incode" |
*
* @param {Shortcut_Keys_Desc_Chain_To_Next_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_chain_to_next_event = /** @type {((inputs?: Shortcut_Keys_Desc_Chain_To_Next_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Chain_To_Next_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Accrocher l'outcode de l'evenement a l'incode de l'evenement suivant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ordne den Ausgabecode des Ereignisses dem Eingabecode des nächsten Ereignisses zu.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Collega l'outcode dell'evento all'incode dell'evento successivo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сопоставьте исходящий код события с входящим кодом следующего события.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajustar el código de salida del evento al código de entrada del siguiente evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将事件的输出代码与下一个事件的输入代码对齐。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントのアウトコードを次のイベントのインコードにスナップします")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट के आउटकोड को अगले इवेंट के इनकोड से स्नैप करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sincronize o código de saída do evento com o código de entrada do próximo evento.")
	return /** @type {LocalizedString} */ ("Snap the Event outcode to the next Event's incode")
});